module.exports = __webpack_public_path__ + "img/no-avatar-project.ee21aa42.svg";